import React, { useEffect, useState } from "react";
import SettingLayout from "./Components/SettingLayout";
import "./style.scss";
import { Button, notification, Radio, Switch } from "antd";
import type { RadioChangeEvent } from "antd";
import { mixPostV1 } from "../../services/mixin";

// CHECK ROLE = 'USER'
const user = JSON.parse(localStorage.getItem("user") || "{}");
const permission = user.permission;
const settingRole = permission
  ? permission.find((item: any) => item.function_id === 7)
  : null;

const Reporting: React.FC = () => {
  const [reportingMethod, setReportingMethod] = useState(1);
  const [requireProofOfCashout, setRequireProofOfCashout] = useState(0);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [api, contextHolder] = notification.useNotification();
  let waitx1 = 0;
  const gConfigSetting = async () => {
    if (waitx1 > 0) {
      return;
    }
    waitx1 = 1;
    const res = await mixPostV1("/api/webAdmin/gConfigSetting.php", {});
    if (res.status === 1) {
      setReportingMethod(res.data.reporting_method ?? 1);
      setRequireProofOfCashout(res?.data?.is_require_proof_cashout ?? 0);
    }
  };
  const options = [
    {
      value: 2,
      label: (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <span
            style={{ fontWeight: "bold", fontSize: 16, lineHeight: "24px" }}
          >
            Simple Reporting (Individual Shift Closing)
          </span>
          <span style={{ fontSize: 14, marginTop: 2, color: "#ccc" }}>
            Ideal for when each staff member works a shift independently or is
            individually responsible for their own shift. Staff will summarize
            and submit a single report at the end of their work period.
          </span>
        </div>
      ),
    },
    {
      value: 1,
      label: (
        <div style={{ display: "flex", flexDirection: "column" }}>
          <span
            style={{ fontWeight: "bold", fontSize: 16, lineHeight: "24px" }}
          >
            Manager-Led Reporting (Team Shift Closing)
          </span>
          <span style={{ fontSize: 14, marginTop: 2, color: "#ccc" }}>
            Ideal for when a shift has multiple staff members working together
            under one person with primary responsibility (Shift Lead/Manager).
            Staff members will log their activities, and the Shift Lead will
            then compile and close the final report for the entire shift.
          </span>
        </div>
      ),
    },
  ];

  const updateReportingMethod = async () => {
    const res = await mixPostV1("/api/webAdmin/editReportingMethodConfig.php", {
      reporting_method: reportingMethod,
      is_require_proof_cashout: requireProofOfCashout,
    });
    if (res.status) {
      setConfirmLoading(false);
      waitx1 = 0;
      gConfigSetting();
      openNotification();
    } else {
      setConfirmLoading(false);
      openNotification("error", "Something went wrong!");
    }
  };
  const openNotification = (
    type: "success" | "info" | "warning" | "error" = "success",
    message = "Reporting method updated!",
  ) => {
    api[type]({
      message: message,
      placement: "bottomRight",
      className: "single-message",
    });
  };
  useEffect(() => {
    gConfigSetting();
  }, []);
  return (
    <SettingLayout current="reporting">
      <div className="setting-content setting-content--update setting-shift reporting-bg">
        {contextHolder}
        <div className="mw-596 shift-content">
          <div style={{ fontWeight: "bold", fontSize: 18, marginBottom: 16 }}>
            Reporting method
          </div>

          <Radio.Group
            value={reportingMethod}
            onChange={(e: RadioChangeEvent) =>
              setReportingMethod(e.target.value)
            }
            style={{ display: "flex", flexDirection: "column", gap: 24 }}
          >
            {options.map((opt) => (
              <Radio
                key={opt.value}
                value={opt.value}
                style={{
                  alignItems: "flex-start",
                  display: "flex",
                  padding: "8px 0",
                  color: "#fff",
                }}
              >
                {opt.label}
              </Radio>
            ))}
          </Radio.Group>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 12,
              marginTop: 24,
              padding: "12px 16px",
              background: "#1a1a1a",
              borderRadius: 8,
            }}
          >
            <span
              style={{
                fontWeight: "bold",
                fontSize: 14,
                color: "#fff",
                flex: 1,
              }}
            >
              Require Proof of Cashout
            </span>
            <Switch
              checked={requireProofOfCashout === 1}
              onChange={(checked) => setRequireProofOfCashout(checked ? 1 : 0)}
              disabled={settingRole && settingRole.is_edit === 0}
              style={{
                backgroundColor: requireProofOfCashout ? "#52c41a" : "#555",
              }}
            />
          </div>
        </div>
        <Button
          className="rs-button button-update"
          type="primary"
          disabled={settingRole && settingRole.is_edit === 0}
          loading={confirmLoading}
          onClick={() => updateReportingMethod()}
        >
          Update
        </Button>
      </div>
    </SettingLayout>
  );
};

export default Reporting;
